<template>
  <div class="log-oppea-box">
    <div class="item">操作用户：{{rowItem.operatedUserPO && rowItem.operatedUserPO.realName}}</div>
    <div class="item">被操作对象：{{form && form.updateTag}}</div>
    <div class="item">修改时间：{{rowItem.operatedTime}}</div>
    <el-row v-if="form" :gutter="20">
      <el-col :span="12" v-if="beforeShare">
        <div class="grid-content">
          <div class="title">变更前</div>
          <div class="info-item" v-if="beforeShare">
            <div class="product-image" v-if="beforeShare.coverImage">
              <el-image :src="beforeShare.coverImage" alt="封面" :preview-src-list="[beforeShare.coverImage]"  style="width: 120px; height: 70px;"/>

            </div>
            <div class="title-with-product">
              <p>
                <span v-for="(it,idx) in beforeShare.titleDisplay" :key="idx">{{it.titleName}}【{{Number(it.isEdit)===1?'可编辑':'不可编辑'}}】</span>
              </p>
            </div>
          </div>
          <el-descriptions :column="1">
            <el-descriptions-item label="虚拟浏览量">{{beforeShare.browseNum || 0}}</el-descriptions-item>
            <el-descriptions-item label="虚拟点赞量">{{beforeShare.likeNum || 0}}</el-descriptions-item>
            <el-descriptions-item label="虚拟转发量">{{beforeShare.forwardNum || 0}}</el-descriptions-item>
            <el-descriptions-item label="页面排序">{{beforeShare.orderNo}}</el-descriptions-item>
            <el-descriptions-item label="状态">{{beforeShare.state === 1 ? '启用' : beforeShare.state === 0 ? '禁用' : '--'}}</el-descriptions-item>
          </el-descriptions>
          <el-descriptions :column="1">
            <el-descriptions-item label="文章logo图">
              <el-image v-if="beforeShare.logoImg" style="width: 80px; height: 80px; border-radius: 50%" :src="beforeShare.logoImg" :preview-src-list="[beforeShare.logoImg]"></el-image>
            </el-descriptions-item>
            <el-descriptions-item label="技术老师描述">{{beforeShare.teacherIsEdit?'允许' : '不允许'}}分享时更换技术老师</el-descriptions-item>
          </el-descriptions>
          <el-descriptions :column="1">
            <el-descriptions-item label="时间">{{beforeShare.contactTime}}</el-descriptions-item>
            <el-descriptions-item label="联系人">{{beforeShare.contactName}}</el-descriptions-item>
            <el-descriptions-item label="联系电话">{{beforeShare.contactPho}}</el-descriptions-item>
            <el-descriptions-item label="地址">{{beforeShare.contactAddress}}</el-descriptions-item>
          </el-descriptions>
          <div class="content-blocks" v-if="beforeContent.length > 0">
            <div v-for="(item,idx) in beforeContent" :key="idx" class="content-block mb10" :class="Number(item.isEdit) === 1 ? 'editable-block' : 'non-editable-block'">
              <div class="block-content">
                <div class="block-features">
                  <div class="feature-item" v-html="item.content"></div>
                </div>
              </div>
              <div class="block-tag" :class="Number(item.isEdit) === 1 ? 'editable-tag' : 'non-editable-tag'">{{ Number(item.isEdit) === 1 ? '可编辑' : '不可编辑' }}</div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="12" v-if="afterShare">
        <div class="grid-content log-line">
          <div class="title">变更后</div>
          <div class="info-item" v-if="afterShare">
            <div class="product-image" v-if="afterShare.coverImage">
              <el-image :src="afterShare.coverImage" alt="封面" :preview-src-list="[afterShare.coverImage]"  style="width: 120px; height: 70px;"/>
            </div>
            <div class="title-with-product">
              <p>
                <span v-for="(it,idx) in afterShare.titleDisplay" :key="idx">{{it.titleName}}【{{Number(it.isEdit)===1?'可编辑':'不可编辑'}}】</span>
              </p>
            </div>
          </div>
          <el-descriptions :column="1">
            <el-descriptions-item label="虚拟浏览量">{{afterShare.browseNum || 0}}</el-descriptions-item>
            <el-descriptions-item label="虚拟点赞量">{{afterShare.likeNum || 0}}</el-descriptions-item>
            <el-descriptions-item label="虚拟转发量">{{afterShare.forwardNum || 0}}</el-descriptions-item>
            <el-descriptions-item label="页面排序">{{afterShare.orderNo}}</el-descriptions-item>
            <el-descriptions-item label="状态">{{afterShare.state === 1 ? '启用' : afterShare.state === 0 ? '禁用' : '--'}}</el-descriptions-item>
          </el-descriptions>
          <el-descriptions :column="1">
            <el-descriptions-item label="文章logo图">
              <el-image v-if="afterShare.logoImg" style="width: 80px; height: 80px; border-radius: 50%" :src="afterShare.logoImg" :preview-src-list="[afterShare.logoImg]"></el-image>
            </el-descriptions-item>
            <el-descriptions-item label="技术老师描述">{{afterShare.teacherIsEdit?'允许' : '不允许'}}分享时更换技术老师</el-descriptions-item>
          </el-descriptions>
          <el-descriptions :column="1">
            <el-descriptions-item label="时间">{{afterShare.contactTime}}</el-descriptions-item>
            <el-descriptions-item label="联系人">{{afterShare.contactName}}</el-descriptions-item>
            <el-descriptions-item label="联系电话">{{afterShare.contactPho}}</el-descriptions-item>
            <el-descriptions-item label="地址">{{afterShare.contactAddress}}</el-descriptions-item>
          </el-descriptions>
          <div class="content-blocks" v-if="afterContent.length > 0">
            <div v-for="(item,idx) in afterContent" :key="idx" class="content-block mb10" :class="Number(item.isEdit) === 1 ? 'editable-block' : 'non-editable-block'">
              <div class="block-content">
                <div class="block-features">
                  <div class="feature-item" v-html="item.content"></div>
                </div>
              </div>
              <div class="block-tag" :class="Number(item.isEdit) === 1 ? 'editable-tag' : 'non-editable-tag'">{{ Number(item.isEdit) === 1 ? '可编辑' : '不可编辑' }}</div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
 </template>

<script>
import sysDataCompareLogApi from '@/api/log/sysDataCompareLog'
export default {
  props: ['rowItem'],
  data() {
    return {
      form: null,
      beforeShare: null,
      afterShare: null,
      beforeContent: [],
      afterContent: []
    }
  },
  created() {
    this.getLogShow()
  },
  methods: {
    getLogShow() {
      sysDataCompareLogApi.fetchById(this.rowItem.id).then(res => {
        this.form = res.data;
        const before = res.data && res.data.beforeStr && res.data.beforeStr.templateMaterialsShare
        const after = res.data && res.data.afterStr && res.data.afterStr.templateMaterialsShare
        this.beforeShare = this.normalizeShare(before)
        this.afterShare = this.normalizeShare(after)
        this.beforeContent = this.parseContentList(this.beforeShare && this.beforeShare.content)
        this.afterContent = this.parseContentList(this.afterShare && this.afterShare.content)
      })
    },
    normalizeShare(obj) {
      if (!obj) return null
      const safe = (v) => (v == null ? undefined : v)
      // 优先使用 title_json，如果不存在则使用 titleDisplay
      const titleSource = obj.title_json||obj.title
      const parsedTitle = this.parseTitleList(titleSource)
      return {
        coverImage: safe(obj.cover_image) || safe(obj.coverImage),
        titleDisplay: parsedTitle,
        browseNum: Number(obj.browse_num != null ? obj.browse_num : obj.browseNum),
        likeNum: Number(obj.like_num != null ? obj.like_num : obj.likeNum),
        forwardNum: Number(obj.forward_num != null ? obj.forward_num : obj.forwardNum),
        orderNo: obj.order_no != null ? obj.order_no : obj.orderNo,
        state: obj.state,
        logoImg: safe(obj.logo_img) || safe(obj.logoImg),
        teacherIsEdit: Number(obj.teacher_is_edit != null ? obj.teacher_is_edit : obj.teacherIsEdit) === 1,
        contactTime: safe(obj.contact_time) || safe(obj.contactTime),
        contactName: safe(obj.contact_name) || safe(obj.contactName),
        contactPho: safe(obj.contact_pho) || safe(obj.contactPho),
        contactAddress: safe(obj.contact_address) || safe(obj.contactAddress),
        content: obj.content
      }
    },
    parseTitleList(input) {
      try {
        const arr = typeof input === 'string' ? JSON.parse(input) : input
        return Array.isArray(arr) ? arr : []
      } catch(e) {
        return []
      }
    },
    parseContentList(input) {
      try {
        const arr = typeof input === 'string' ? JSON.parse(input) : input
        return Array.isArray(arr) ? arr : []
      } catch(e) {
        return []
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.title-box {
  margin: 10px 24px 15px 0;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 5px;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
  }
}
.info-item {
  display: flex;
  .product-image {
    width: 120px;
    height: 68px;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .title-with-product{
    .p1{
      font-size: 14px;
      color: #6C6C6C;
    }
  }
}
.content-blocks {
  .content-block {
    position: relative;
    border: 1px solid #e4e7ed;
    border-radius: 8px;
    padding: 10px;
    background: #fafafa;
    .block-tag {
      position: absolute;
      top: 6px;
      right: 6px;
      font-size: 12px;
      padding: 2px 6px;
      border-radius: 4px;
      &.editable-tag {
        color: #67c23a;
        background: #f0f9ff;
        border: 1px solid #67c23a;
      }
      &.non-editable-tag {
        color: #909399;
        background: #f5f7fa;
        border: 1px solid #909399;
      }
    }
    &.editable-block { border-color: #67c23a; background: #f0f9ff; }
    &.non-editable-block { border-color: #909399; background: #f5f7fa; }
  }
}
</style>
